import axiosInstance from 'utils/axiosInstance';
import successHandler from './successHandler';
import errorHandler from './errorHandler';
import {getDefaultReqConfig} from './defaultReqConfig';
import {getDefaultCampignReqConfig} from './defaultConfigForCampign';
const request={
   
  create:async({endPoint,jsonData})=>{
        try
        {
         const defaultReqConfig=getDefaultReqConfig();
         const defaultCampignReqConfig= getDefaultCampignReqConfig()
         const response=await axiosInstance.post(endPoint,jsonData,{
          headers: {
            "X-Data-Token": defaultReqConfig,
            "X-cmpgn-tkn" : defaultCampignReqConfig
          }});
          successHandler(response);
          return response.data
        }
        catch(error)
        {
          errorHandler(error)
        }
    },
    read: async ({ endPoint}) => {
      const defaultReqConfig=getDefaultReqConfig();
      const defaultCampignReqConfig= getDefaultCampignReqConfig()
      try {
        const response = await axiosInstance.get(endPoint,{headers:{
          "X-Data-Token": defaultReqConfig,
          "X-cmpgn-tkn" : defaultCampignReqConfig
         }});
        successHandler(response);
        return response.data;
      } catch (error) {
        return errorHandler(error);
      }
    },
    delete: async ({endPoint,id }) => {
      const defaultReqConfig=getDefaultReqConfig();
      const defaultCampignReqConfig= getDefaultCampignReqConfig()
      try {
        const response = await axiosInstance.delete(endPoint,{
          headers: {
            "X-Data-Token": defaultReqConfig,
            "X-cmpgn-tkn" : defaultCampignReqConfig
          }},id);
        successHandler(response);
        return response.data;
      } catch (error) {
        return errorHandler(error);
      }
    },

}
export default request;